/**
 * Feature flag — the Resources tab in Settings (resource provisioning,
 * PROD-2007 epic / PROD-2010 FE story).
 *
 * Reads `VITE_RESOURCES_TAB`. Vite inlines the value at build time, so this
 * resolves on first call and does not subscribe to runtime changes — toggling
 * the flag requires a rebuild.
 *
 * FAIL-CLOSED. Absent or unrecognised = OFF, which removes both the tab entry
 * (settings-tabs.ts) and the /settings/resources* routes (settings-routes.tsx)
 * from the build entirely. That default is why the whole epic was invisible on
 * dev until the variable was actually declared somewhere.
 *
 * Where it is set:
 *   dev-web.yml     "true"  — the surface is backed by the live registry
 *                             (PracticeManagement PR #942 / PROD-2008) with the
 *                             exam-room migration applied to dev.
 *   prod-web.yml    unset   — prod stays off until the dev sign-off.
 *   .env.development unset  — local `npm run dev` opts in via .env.local.
 *
 * Coercion rules match `use-clinic-edit-rail-enabled.ts` (case-insensitive,
 * trimmed): 'true' / '1' / 'on' → true; everything else → false.
 */
import { coerceFlag } from './use-clinic-edit-rail-enabled';

/** Module-scope value for non-hook consumers (settings-tabs is plain data). */
export const RESOURCES_TAB_ENABLED: boolean = coerceFlag(
  import.meta.env.VITE_RESOURCES_TAB,
);

/**
 * Returns whether the Resources settings tab is enabled for the current build.
 */
export function useResourcesTabEnabled(): boolean {
  return RESOURCES_TAB_ENABLED;
}
